<template>
    <!-- Contador − n + (mismo que la demo: botones con etiqueta, número como output) -->
    <div :class="['ee-ct', { 'is-locked': disabled }]">
        <span :id="`${id}-l`" class="ee-ct-l">{{ label }}<small v-if="nota">{{ nota }}</small></span>
        <div class="ee-ct-c" role="group" :aria-labelledby="`${id}-l`">
            <button type="button" class="ee-ct-b" :aria-label="$t('editor_espacio.ct.less', { x: label })" :disabled="disabled || valor <= min" @click="cambiar(-1)" v-html="ICON.minus"></button>
            <output :id="id" aria-live="polite">{{ valor }}</output>
            <button type="button" class="ee-ct-b" :aria-label="$t('editor_espacio.ct.more', { x: label })" :disabled="disabled || valor >= max" @click="cambiar(1)" v-html="ICON.plus"></button>
        </div>
    </div>
</template>

<script>
import { ICON } from './iconos';

export default {
    name: 'EeContador',
    props: {
        id: { type: String, required: true },
        label: { type: String, required: true },
        value: { type: [Number, String], default: 0 },
        min: { type: Number, default: 0 },
        max: { type: Number, default: 99 },
        disabled: { type: Boolean, default: false },
        nota: { type: String, default: '' },
    },
    data() { return { ICON }; },
    computed: {
        valor() { return parseInt(this.value, 10) || 0; },
    },
    methods: {
        cambiar(d) {
            const v = Math.min(this.max, Math.max(this.min, this.valor + d));
            this.$emit('input', v);
        },
    },
};
</script>
